/* eslint-disable react/display-name */
import { lazy } from "react";

const EspPage = lazy(() => import("./pages/esp"));
const ConveyorPage = lazy(() => import("./pages/conveyor"));
const CabinetPage = lazy(() => import("./pages/cabinet"));
const ChutePage = lazy(() => import("./pages/chute"));
const StationLayoutPage = lazy(() => import("./pages/station-layout"));

const LegoStatisticPage = lazy(() => import("../wms/pages/lego/statistic"));
const LegoListPage = lazy(() => import("../wms/pages/lego/list"));
const LegoPlanPage = lazy(() => import("../wms/pages/lego/plan"));

export const LegoRoutes = [
  { path: "esp", element: <EspPage /> },
  { path: "conveyor", element: <ConveyorPage /> },
  { path: "cabinet", element: <CabinetPage /> },
  { path: "chute", element: <ChutePage /> },
  { path: "station-layout", element: <StationLayoutPage /> },

  { path: "statistic", element: <LegoStatisticPage /> },
  { path: "list", element: <LegoListPage /> },
  { path: "plan/:legoId", element: <LegoPlanPage /> }
];
export default LegoRoutes;
